import React from "react";
import { Product } from "types/searchApi/response";

const { useContext } = React;

interface RecommendationsData {
  popularSuggestions?: {
    podId?: string;
    resultId?: string;
    numResults?: number;
    strategyIds?: string[];
  };
  popularProducts?: {
    podId?: string;
    resultId?: string;
    numResults?: number;
  };
}

export interface DataContext {
  searchedTerm?: string;
  products?: Product[];
  brands?: string[];
  searches: {
    recent?: string[];
    suggested?: string[];
  };
  isRecommendations: boolean;
  recommendationsData?: RecommendationsData;
}

const DataContext = React.createContext<DataContext>({} as DataContext);
DataContext.displayName = "ASDataContext";

export const DataContextProvider = React.memo(DataContext.Provider);

export const useDataContext = () => useContext(DataContext);
